import React from 'react'
import { Link } from 'react-router'

const SupervisorProfileDigest = ({ userProfile: { first_name, last_name } }) => (
  <div className="profile-digest">
    {/* <Link to="/dashboard/profile">
      <div className="profile-pic">
        <i className="fa fa-user" aria-hidden="true" />
      </div>
    </Link> */}

    <Link to="/dashboard/profile">
      <span>{`${first_name || ''} ${last_name || ''}`}</span>
    </Link>
  </div>
)

export default SupervisorProfileDigest



// WEBPACK FOOTER //
// ./src/components/supervisor/SupervisorProfileDigest.js